import {useQuery} from '@tanstack/react-query';
import {useHostName} from 'presentation/hooks';
import {getUserInfoFromToken} from 'presentation/utils';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {postToken} from '../../services/postToken';

export function useCreateTokenQuery() {
	const {ansRegister} = useHostName();
	const {cdUsuario: walletCode} = getUserInfoFromToken();

	return useQuery({
		queryKey: [QUERY_KEYS.CREATE_TOKEN, walletCode, ansRegister],
		queryFn: async ({signal}) => postToken({walletCode, ansRegister, signal}),
		enabled: !!walletCode && !!ansRegister,
		staleTime: 0,
	});
}
